module.exports = __webpack_public_path__ + "static/media/john-sisk-son.98d2a92e.png";